import Money from '../money';

interface SavingProps {
  amount: number;
  prefix?: string;
  suffix?: string;
}

const Saving = ({ prefix = 'Save ', amount, suffix }: SavingProps) => {
  return (
    <span className="ac-pricing__saving ch-text--center">
      {prefix}
      <Money amount={amount} />
      {suffix}
    </span>
  );
};

export default Saving;
